import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Divider from '@mui/material/Divider'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { getEnv } from '@/utils/helpers'

const EDITOR_NAME = 'PROMOTAL'
// EX_GEN-1180 : le nom et la version affichés doivent correspondre aux données LPS_Nom / LPS_Version du VIHF
const SOFTWARE_NAME = 'PROMOTAL MEDCONNECT'
const SOFTWARE_VERSION = '1'

const HOMOLOGATED_PROFILES = ['Consultation Web-PS (TD0.1, TD0.2, TD0.3, TD0.4, TD0.9, TD1.3, TD1.6, TD3.1, TD3.2, TD3.3b)']

const INTEGRATED_COMPONENTS = [
  { name: 'DmpConnect-JS2', editor: 'icanopée' },
  { name: 'EFFICIENCE', editor: 'icanopée' },
]

export type AboutDialogProps = {
  open: boolean
  onClose: () => void
}

export function AboutDialog({ open, onClose }: AboutDialogProps) {
  useLingui()
  const homologationDate = getEnv('VITE_DMP_HOMOLOGATION_DATE')

  return (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { minWidth: 480 } }}>
      <DialogTitle>{t`About MEDCONNECT`}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              {t`Software`}
            </Typography>
            <Row label={t`Editor`} value={EDITOR_NAME} />
            <Row label={t`Software name`} value={SOFTWARE_NAME} />
            <Row label={t`Version`} value={SOFTWARE_VERSION} />
            <Row label={t`DMP homologation date`} value={homologationDate || t`Homologation in progress`} />
            <Row label={t`Homologated DMP-compatibility profiles`} value={HOMOLOGATED_PROFILES.join(' • ')} />
          </Stack>

          <Divider />

          <Stack spacing={1}>
            <Typography variant="subtitle2" color="text.secondary">
              {t`Compliant integrated components`}
            </Typography>
            {INTEGRATED_COMPONENTS.map((c) => (
              <Row key={c.name} label={c.name} value={c.editor} />
            ))}
            <Typography variant="body2" color="text.secondary">
              {t`PROMOTAL MEDCONNECT integrates the EFFICIENCE WEB software by icanopée (CNDA-compliant component) for all DMP access functions. The DMP screens displayed in MEDCONNECT, including their "About" window, belong to this integrated component.`}
            </Typography>
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: '0 24px 16px' }}>
        <Button variant="contained" onClick={onClose}>
          {t`Close`}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

function Row({ label, value }: { label: string; value: string }) {
  return (
    <Stack direction="row" spacing={1} alignItems="flex-start">
      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 220 }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ flex: 1 }}>
        {value}
      </Typography>
    </Stack>
  )
}
